import React from 'react'
import Font from '@cred/react-font'
import { Collapse } from 'react-collapse'
import PropTypes from 'prop-types'

export const disclaimerContents = {
  'Stearns Lending': `Credible Operations and Stearns Lending are not affiliated.  This is not a commitment to lend.
  Program restrictions apply.  Rates and pricing are subject to change without notice.  Stearns
  Lending, LLC, also operates under the trade name Stearns Home Loans in all states except Arizona,
  Massachusetts, and New York.  Stearns Lending, LLC, is a California Limited Liability Company
  headquartered at 401 E. Corporate Drive, Suite 150, Lewisville, Texas 75067. (855) 839-6487.
  Company NMLS# 1854 (www.nmlsconsumeraccess.org).  Stearns Lending, LLC, is licensed, registered,
  or exempt from licensing to conduct business in the following states which require license
  disclosure on advertising materials: Arizona Mortgage Banker License #0905413; Licensed by the
  Department of Financial Protection and Innovation (DFPI) under the California Residential Mortgage
  Lending Act RMLA# 41DBO-30495; Georgia Residential Mortgage Licensee #24066; Kansas Licensed Mortgage
  Company #MC.0025047; Massachusetts Mortgage Lender/Broker License #MC1854; Licensed by the Mississippi
  Department of Banking and Consumer Finance; Missouri Mortgage Company License #19-2052 (Stearns'
  in-state office is located at 111 West Port Plaza, Ste. #639, St. Louis, MO 63143); Licensed by
  the New Hampshire Banking Department; Licensed by the N.J. Department of Banking and Insurance;
  Ohio Certificate of Registration #MB.804022.000; Rhode Island Licensed Lender; Registered under
  Texas SML Mortgage Banker Registration; Virginia State Corporation Commission Lender/Broker License
  #MC-2184; Washington Consumer Loan Company License #CL-1854. For State of Nevada residents Stearns
  Lending, LLC, is a mortgage lender offering some or all of the loan products advertised on this
  website; the business phone number that Stearns Lending maintains on file with the State of Nevada
  Department of Business and Industry is (855) 839-6487.`,
}

const getDisclaimerContent = lenderName => disclaimerContents[lenderName]

const DisclaimerContent = ({ className, lenderName, isOpen }) => (
  <div className={className}>
    <Collapse isOpened={isOpen}>
      <Font className="mt-16" type="bodySmall">{getDisclaimerContent(lenderName)}</Font>
    </Collapse>
  </div>
)

DisclaimerContent.propTypes = {
  className: PropTypes.string,
  lenderName: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
}
DisclaimerContent.defaultProps = {
  className: '',
}

export default DisclaimerContent
